import React from 'react';

const STATUS_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  current:        { bg: 'var(--ds-success-bg)', text: 'var(--success-700)', label: 'Current' },
  met:            { bg: 'var(--ds-success-bg)', text: 'var(--success-700)', label: 'Met' },
  'pending-review': { bg: 'var(--ds-warning-bg)', text: 'var(--warning-700)', label: 'Pending Review' },
  partial:        { bg: 'var(--ds-warning-bg)', text: 'var(--warning-700)', label: 'Partial' },
  outdated:       { bg: 'var(--ds-warning-bg)', text: 'var(--warning-700)', label: 'Outdated' },
  missing:        { bg: 'var(--ds-danger-bg)', text: 'var(--error-700)', label: 'Missing' },
  'non-compliant': { bg: 'var(--ds-danger-bg)', text: 'var(--error-700)', label: 'Non-compliant' },
  'not-applicable': { bg: 'var(--gray-100)', text: 'var(--ds-text-muted)', label: 'N/A' },
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const config = STATUS_COLORS[status.toLowerCase()] ?? STATUS_COLORS['not-applicable'];

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 'var(--ds-radius-pill)',
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: config.bg,
        color: config.text,
        whiteSpace: 'nowrap',
      }}
    >
      {config.label}
    </span>
  );
};
